import React, { Component } from 'react';
import { Panel } from "react-bootstrap";

import paymentMethods from "@modules/softwareIntegration/payment-methods";
import Spinner from '@components/Spinner';
import Table from "@modules/Table";

import '@assets/css/apiData.css';

import { toFormattedNumber } from "@sm/utils/utils";
import { DASHBOARD_DEPOSITS_PROCESSING_FEE } from '@sm/actions/types';
const store =  require('@sm/reducers/index');

class DashBoardDepositsProcessingFee extends Component {

  constructor(props) {
    super(props);

    this.state = {
      depositsFees: undefined,
      loading: true,
      socket: false,
      columns: [{
        value: "method",
        label: "Payment Method"
      }, {
        value: "currency",
        label: "Currency"
      }, {
        value: "deposits",
        label: "Payments",
        rightAligned: true,
        isNumber: true
      }, {
        value: "rate",
        label: "Rate",
        rightAligned: true,
        isNumber: true
      }, {
        value: "processingFees",
        label: "Processing Fees",
        rightAligned: true,
        isNumber: true
      }]
    };
  }

  subscribeFunction = null;

  componentDidMount(){
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_DEPOSITS_PROCESSING_FEE && this.props.thisMonth && state.depositsFees.socket) {
        this.setState({ depositsFees: state.depositsFees, loading: false, socket: state.depositsFees.socket });
        return;
      }

      if (state.update === DASHBOARD_DEPOSITS_PROCESSING_FEE && !state.depositsFees.socket) {
        this.setState({ depositsFees: state.depositsFees, loading: false, socket: state.depositsFees.socket });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  tableData = () => {
    const { depositsFees } = this.state;

    if (!depositsFees) {
      return [];
    }

    return depositsFees.map(elem => {
      return {
        method: paymentMethods[elem.method],
        currency: elem.currency,
        deposits: toFormattedNumber(elem.deposits),
        rate: elem.rate + "%",
        processingFees: toFormattedNumber(elem.processingFees)
      };
    });
  };

  render() {
    const { depositsFees, loading, columns } = this.state;

    let depositWrap = (
      <Panel>
        <Panel.Heading>
          <Panel.Title> PAYMENT PROCESSING FEES </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Spinner smallContainer={ true } />
        </Panel.Body>
      </Panel>
    );

    if (!loading && depositsFees) {
      depositWrap = (
        <Panel style={ { height: '100%' } }>
          <Panel.Heading>
            <Panel.Title> PAYMENT PROCESSING FEES </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="panel-content table-content">
              <Table
                columns={ columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
                isStriped={ false }
              />
            </div>
          </Panel.Body>
        </Panel>
      );
    }
    return depositWrap;
  }

}

export default DashBoardDepositsProcessingFee;